// extracted by mini-css-extract-plugin
export default {"header":"style_header__y-2A1","logo":"style_logo__a+o60","ul":"style_ul__wUvji","li":"style_li__0uGiT"};